import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import CredentialCardSet from '@nmx/template/dist/componentLibrary/modules/CredentialCardSet';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { ColStyled } from './styles';

export default () => (
  <SectionContainer
    id='who-we-are-credential-callout-grouping'
    backgroundVariant='darkDefault'
    themeType='darkTheme'
    moduleName='credentials-module'
    moduleVariation='A'>
    <Row align="center">
      <Col medium={8}>
        <Typography
          align='center'
          component='h2'
          nextElement='typography'
          themeType='darkTheme'>
          Your financial strength, powered <WidowBlock>by ours.</WidowBlock>
        </Typography>
        <Typography
          nextElement='graphic'
          themeType='darkTheme'>
          You can focus on all your big plans when your financial plan is backed by the strength of Northwestern Mutual.
        </Typography>
      </Col>
    </Row>
    <CredentialCardSet
      accentColorVariant='gold'
      accentOrientation='vertical'
      backgroundVariant='darkDefault'
      credentials={[
        {
          credential: 'financialStrengthRating',
          sup1: <>2</>,
        },
        {
          credential: 'totalDividendPayout',
          sup1: <>3</>,
        },
        {
          credential: 'rankedInvestmentService',
          sup1: <>7</>,
        },
      ]}
      hasAccent
      themeType='darkTheme'
    />
    <Row align='center'>
      <ColStyled>
        <Link
          id='who-we-are-credential-callout-grouping-cta'
          variant='buttonLinkSecondary'
          themeType='darkTheme'
          linkUrl='/financial-information/'>
          See more about our financial strength
        </Link>
      </ColStyled>
    </Row>
  </SectionContainer>
);
